module.exports = __webpack_public_path__ + "img/chat_question.ed701c96.svg";